import { TranslationKey, useTranslation } from 'module/hooks/use-translation';
import { BooleanFieldFilter } from 'module/types/filter-field/filter/boolean';
import { snakeCase, startCase } from 'lodash';
import { FC } from 'react';
import { removeTrailingDots } from './utils';

export const BooleanFilterToText: FC<
  React.PropsWithChildren<{ filter: BooleanFieldFilter }>
> = ({ filter }) => {
  const {
    field: { fieldLabel },
    type,
  } = filter;

  return (
    <span>
      {startCase(fieldLabel)}{' '}
      {removeTrailingDots(
        useTranslation(
          `task_list.filters.${snakeCase(type)}` as TranslationKey,
        ),
      )}
    </span>
  );
};
